import collectionUtils from './collectionUtils'
import publisherUtils from './publisherUtils'
import i18n from 'i18n'

export const getUnitLabel = ({ collection, publisher, labelSuffix, hasEndpoint }) => {
  let prefix = ''
  const NUMBER_REGEX = /\d/g

  if (publisher && publisherUtils.isCasaDuartePublisher(publisher.id)) {
    prefix = i18n.t('Unidad')
  } else if (collectionUtils.isFaroCollection(collection)) {
    prefix = i18n.t('Unidad Didáctica')
  } else if (labelSuffix[0].match(NUMBER_REGEX)) {
    prefix = i18n.t('Tema')
  }

  const endPoint = hasEndpoint ? '.' : ''

  return `${prefix} ${labelSuffix}${endPoint}`
}
